import { Breakpoint } from '../../../../hooks/useWidthBreakpoint';

export type Responsive<T> = { sm: T; md: T; lg: T };

export const pick = <T>(breakpoint: Breakpoint, values: Responsive<T>): T =>
  values[breakpoint];
